import { useMemo } from 'react';
import { cn } from '../../common/functions/cn';
import useDOMPurify from '../../common/hooks/use-dom-purify';
import InnerHTMLDiv from '../common/inner-html-div.component';
import type { DynamicFieldComponentProps } from '../dynamic-form/dynamic-form.interfaces';
import ErrorLabel from './error-label';
import FieldLabel from './field-label';

export default function DataLabel({ label, value, error, labelStyles }: DynamicFieldComponentProps<string>) {
  const { sanitize } = useDOMPurify();
  const sanitizedValue = useMemo(() => sanitize(value ?? ''), [value, sanitize]);

  const valueStyles = cn('text-sm [&_a]:underline [&_a]:text-url');

  return (
    <>
      {label && <FieldLabel label={label} labelStyles={labelStyles} />}
      {value && <InnerHTMLDiv className={valueStyles} html={sanitizedValue} sanitize={false} />}
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </>
  );
}
